import { render } from "./MetricsList.vue?vue&type=template&id=d244f816"
import script from "./MetricsList.vue?vue&type=script&lang=js"
export * from "./MetricsList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
